import { render, staticRenderFns } from "./SetUpIncomeTableCmp.vue?vue&type=template&id=72758a52&"
import script from "./SetUpIncomeTableCmp.vue?vue&type=script&lang=js&"
export * from "./SetUpIncomeTableCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports